export default __webpack_public_path__ + "static/media/farm_table.4b2911ba.png";